import assign from 'lodash/assign';
import * as APIS from '../../constants/api';

export const offeringManagement =
  (action, payload) =>
  (dispatch, getState, { api }) =>
    api
      .post(APIS.OFFERING_MANAGEMENT, assign({ action }, payload))
      .then((result) => {
        return result;
      })
      .catch((error) => {
        throw error;
      });

export const a = 1;
